function hasCircuitNextExerciseWorkoutSectionUtil (round, setIndexInRound) {
  return setIndexInRound < round?.length - 1
}

export { hasCircuitNextExerciseWorkoutSectionUtil }
